import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useLanguage } from "@/lib/LanguageContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { ServiceArea } from "@/components/ServiceArea";
import { Reviews } from "@/components/Reviews";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingButtons } from "@/components/FloatingButtons";
import { Toaster } from "@/components/ui/sonner";

export default function MainSite() {
  const { lang: urlLang } = useParams();
  const { lang, changeLanguage } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    if (urlLang && ["en", "pt", "es"].includes(urlLang)) {
      if (urlLang !== lang) {
        changeLanguage(urlLang);
      }
    } else {
      navigate("/");
    }
  }, [urlLang, lang, changeLanguage, navigate]);

  if (!lang) return null;

  return (
    <div data-testid="main-site" className="sousa-app">
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: { background: '#0f3555', border: '1px solid rgba(60,198,198,0.2)', color: '#fff' },
        }}
      />
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <ServiceArea />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
